export const ADD_NEW_PRODUCT = "shipping/addNewProduct";
export const ADD_TO_CART = "shipping/addToCart";
export const INCREMENT = "shipping/increment";
export const DECREMENT = "shipping/decrement";
export const REMOVE_FROM_CART = "shipping/removeFromCart";
